import React from "react"

import * as st from './Modal.styled.js'

const modalStyles = {
  overlay: {
    zIndex: 99,
    background: "rgba(43, 46, 49, 0.85)",
  }
};

const Modal = ({
  className,
  contentLabel,
  isOpen,
  onClose,
  children,
}) => (
  <st.Modal
    className={className}
    isOpen={isOpen}
    style={modalStyles}
    contentLabel={contentLabel}
    shouldCloseOnEsc
    shouldReturnFocusAfterClose
    onRequestClose={onClose}
  >
    {children}
  </st.Modal>
)

export default Modal
